<template>
    <div class="teammates-lineup-wrapper">
        <div class="available-teammates">
            <h6 class="text-left">Available Seeding</h6>
            <div class="teammates-info">
                <draggable class="list-group" :list="availableSeedars" group="people" handle=".handle"
                    @change="handleAvailableSeedars" v-if="showLoaderAvailableSeeadrs == 0">
                    <div class="list-group-item" v-for="(element, index) in availableSeedars" :key="index">
                        <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column">
                                <p class="name">
                                    {{
                                        element?.criteria_name ||
                                        element?.seed_criteria.criteria_name
                                    }}
                                </p>
                            </div>
                        </div>
                        <div class="handle">
                            <img src="../../../assets/images/line-ellipsis.png" alt="" />
                        </div>
                    </div>
                </draggable>
                <div class="no-line-up" v-if="
                    showLoaderAvailableSeeadrs == 0 &&
                    availableSeedars.length == 0
                ">
                    <div class="img">
                        <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No available seeding found.</p>
                </div>
                <div class="lds-dual-ring-media" v-if="showLoaderAvailableSeeadrs == 1"></div>
            </div>
        </div>
        <div class="team-lineup mt-3 mt-md-0">
            <h6 class="text-left">Selected Seeding</h6>
            <div class="teammates-info position-relative">
                <draggable class="list-group" :list="selectedSeedars" group="people" handle=".handle"
                    @change="handleSelectedSeedars" v-if="showLoaderSelectedSeedars == 0">
                    <div class="list-group-item" v-for="(element, index) in selectedSeedars"
                        :key="element?.position_index">
                        <div class="shirt-no-wrapper">
                            <small>{{ index + 1 }}.</small>
                            <div class="d-flex flex-column">
                                <p class="name">{{ element?.criteria_name }}</p>
                            </div>
                        </div>
                        <div class="handle">
                            <img src="../../../assets/images/line-ellipsis.png" alt="" />
                        </div>
                    </div>
                </draggable>
                <div class="no-line-up" v-if="
                    showLoaderSelectedSeedars == 0 &&
                    selectedSeedars.length == 0
                ">
                    <div class="img">
                        <img src="../../../assets/images/teammates.png" alt="" />
                    </div>
                    <p class="text">No selected seeding found.</p>
                </div>
                <div class="lds-dual-ring-media" v-if="showLoaderSelectedSeedars == 1"></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
export default {
    name: "SeedingComponent",
    components: {
        draggable,
    },
    data() {
        return {
            availableSeedars: [],
            selectedSeedars: [],
            showLoaderSelectedSeedars: 1,
            showLoaderAvailableSeeadrs: 1,
        }
    },
    props: {
        eventId: {
            type: [Number, String],
        },
        association_id: {
            type: [Number, String],
        },
    },
    watch: {
        selectedSeedars: function (newValue) {
            if (newValue.length > 0 || this.availableSeedars.length > 0) {
                const isDisabled = false;
                this.$emit('update-state', {
                    isDisabled,
                    selectedSeedars: this.selectedSeedars
                });
            } else {
                const isDisabled = true;
                this.$emit('update-state', isDisabled);
            }
        },
        availableSeedars: function (newValue) {
            if (newValue.length > 0 || this.selectedSeedars.length > 0) {
                const isDisabled = false;
                this.$emit('update-state', {
                    isDisabled,
                    selectedSeedars: this.selectedSeedars
                });
            } else {
                const isDisabled = true;
                this.$emit('update-state', isDisabled);
            }
        },
        eventId: 'tryFetchingSeedars',
        association_id: 'tryFetchingSeedars',
    },
    methods: {
        tryFetchingSeedars() {
            if (this.eventId && this.association_id) {
            this.getEventSeedars();
            this.getSeedarsForAssociation();
            }
        },
        handleAvailableSeedars(evt) {
            if (evt.added) {
                this.selectedSeedars.push(evt.added.element);

            }
        },
        handleSelectedSeedars(evt) {
            if (evt.removed) {
                const index = this.selectedSeedars.indexOf(evt.removed.element);

                if (index > -1) {
                    this.selectedSeedars.splice(index, 1);
                }
            }
        },
        async getEventSeedars() {
            try {
                this.showLoaderAvailableSeeadrs = 1;
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/fetchFilteredSeedars`,
                    {
                        params: {
                            event_id: this.eventId,
                            association_id: this.association_id, // Pass association_id here
                        }
                    }
                );

                if (response.data.statusCode === 200) {

                    this.availableSeedars = Object.values(response.data.data);
                    this.showLoaderAvailableSeeadrs = 0;
                }
                else if (response.data.statusCode === 404) {
                    this.$alert(response.data.message, "Error");
                    this.$router.push({ name: "Teams" });
                }
                else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoaderAvailableSeeadrs = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoaderAvailableSeeadrs = 0;
            }
        },
        async getSeedarsForAssociation() {
            try {
                this.showLoaderSelectedSeedars = 1;
                const response = await axios.get(
                    `${process.env.VUE_APP_API_URL}associationEvent/getEventSelectedSeedars`,
                    {
                        params: {
                            event_id: this.eventId,
                            association_id: this.association_id, // Pass association_id here
                        }
                    }
                );

                if (response.data.statusCode === 200) {

                    this.selectedSeedars = Object.values(response.data.data);
                    this.showLoaderSelectedSeedars = 0;
                }
                else if (response.data.statusCode === 404) {
                    alert("something went wrong")
                }
                else {
                    this.errorMessage = response.data.message || "Unknown error occurred";
                    this.showLoaderSelectedSeedars = 0;
                }
            } catch (error) {
                this.errorMessage = "Failed to fetch data";
                this.showLoaderSelectedSeedars = 0;
            }
        },
    },
    mounted() {
        this.getEventSeedars();
        this.getSeedarsForAssociation();
    }
}

</script>